<template>
  <v-container>
    <!-- Header Section -->
    <v-row>
      <v-col cols="12">
        <v-card class="mb-6 pa-6 primary">
          <v-row align="center">
            <v-col cols="12" md="8">
              <h1 class="text-h3 white--text font-weight-bold mb-2">New Global Market Corp.</h1>
              <div class="subtitle-1 white--text mb-4">
                Innovación tecnológica con estándares globales
              </div>
              <div class="body-1 white--text mb-4">
                <v-icon small class="mr-2" color="white">mdi-check-circle</v-icon>
                Contemplamos normativas ISO 27001 • ISO 27017 • ISO 27018 • SOC 2 Type II
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-4">
                <v-card-text>
                  <div class="mb-2">
                    <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                    <span class="font-weight-medium">2121 Lake Shore Boulevard West, Etobicoke, ON, Canadá</span>
                  </div>
                  <div class="mb-2">
                    <v-icon color="primary" class="mr-2">mdi-web</v-icon>
                    <a href="https://newglobal.market" class="text-decoration-none">newglobal.market</a>
                  </div>
                  <div>
                    <v-icon color="primary" class="mr-2">mdi-email</v-icon>
                    <span>info@newglobal.market</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- AI-BOS Product Section -->
    <v-row>
      <v-col cols="12">
        <v-card class="mb-6">
          <v-card-title class="headline font-weight-bold">
            AI-BOS: Solución Empresarial Inteligente
          </v-card-title>
          
          <v-card-text class="body-1">
            <p class="mb-4">
              <strong>AI-BOS</strong> es un producto diseñado y desarrollado por New Global Market Corp., empresa con sede en Etobicoke, Ontario, Canadá. 
              Esta solución empresarial integra tecnologías de inteligencia artificial para optimizar procesos corporativos, 
              garantizando máxima eficiencia y adaptabilidad en entornos empresariales complejos.
            </p>
            
            <p class="mb-4">
              Como creadores y propietarios exclusivos de AI-BOS, implementamos rigurosos estándares de seguridad, 
              contemplando las directrices de ISO/IEC 27001 para gestión de seguridad de la información, 
              ISO/IEC 27017 para seguridad en la nube, e ISO/IEC 27018 para protección de información personal 
              identificable (PII) en entornos de nube pública.
            </p>
            
            <p class="mb-6">
              Nuestros procesos de desarrollo y manejo de datos tienen en cuenta regulaciones internacionales como GDPR, CCPA, 
              PIPEDA y otras normativas aplicables, buscando que la implementación de AI-BOS en su empresa cumpla con 
              altos estándares de protección de datos y privacidad.
            </p>
            
            <v-row>
              <v-col cols="12" md="6" v-for="(feature, i) in features" :key="i">
                <v-card class="mb-4" outlined>
                  <v-card-title class="title">
                    <v-icon large :color="feature.color" class="mr-2">{{ feature.icon }}</v-icon>
                    {{ feature.title }}
                  </v-card-title>
                  <v-card-text>{{ feature.description }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Legal Information Tabs -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab>Términos y Condiciones</v-tab>
            <v-tab>Políticas</v-tab>
            <v-tab>Confidencialidad</v-tab>
          </v-tabs>
          
          <v-tabs-items v-model="tab">
            <!-- Terms and Conditions -->
            <v-tab-item>
              <v-card flat>
                <v-card-text class="py-4">
                  <p class="body-1 mb-4">
                    Los siguientes Términos y Condiciones de Uso (en adelante "CONDICIONES") regulan el uso de cualquier servicio 
                    o producto que provea NGM - New Global Market Corp., incluyendo AI-BOS, así como la relación entre 
                    NGM - New Global Market Corp. y sus USUARIOS.
                  </p>
                  
                  <p class="body-1 mb-4">
                    Los productos y servicios de NGM - New Global Market Corp. se clasifican en: SaaS (Software as a Service), 
                    Licencias de Uso, y otros servicios (soporte técnico, capacitaciones, certificaciones). En el cuerpo de estas 
                    CONDICIONES existen diferencias en el tratamiento de unos u otros. El USUARIO debe asegurarse de entender y 
                    aceptar aquellas particularidades referentes a los productos y/o servicios que adquiera.
                  </p>
                  
                  <p class="body-1 mb-4">
                    Los productos y servicios de NGM - New Global Market Corp. evolucionarán con el tiempo, por lo que 
                    NGM - New Global Market Corp. se reserva el derecho de modificar estas CONDICIONES, haciéndose efectivas 
                    las modificaciones a partir de su publicación en el sitio web oficial. Es obligación de los USUARIOS 
                    asegurarse de haber leído, comprendido y aceptado las CONDICIONES vigentes disponibles en el sitio web 
                    oficial de NGM - New Global Market Corp.
                  </p>
                </v-card-text>
              </v-card>
            </v-tab-item>
            
            <!-- Policies -->
            <v-tab-item>
              <v-card flat>
                <v-card-text class="py-4">
                  <p class="body-1 mb-4">
                    Debe seguir las políticas disponibles para usted dentro de los 
                    Servicios. No utilice nuestros Servicios de forma indebida. Puede 
                    utilizar nuestros Servicios solo como se permite por ley, 
                    incluidas las leyes y regulaciones correspondientes.
                  </p>
                  
                  <p class="body-1 mb-4">
                    Podremos suspender o dejar de proveerle nuestros Servicios si usted 
                    incumple nuestras condiciones o políticas.
                  </p>
                  
                  <v-alert
                    type="info"
                    outlined
                    class="mb-4"
                  >
                    <p class="mb-0">
                      <strong>DESCARGO DE RESPONSABILIDAD:</strong> EXCEPTO POR LO QUE SE 
                      ESTABLECE EXPRESAMENTE EN ESTAS CONDICIONES O EN CONDICIONES 
                      ADICIONALES, NI NGM Corporation. NI SUS PROVEEDORES O 
                      DISTRIBUIDORES REALIZAN PROMESA ALGUNA ESPECÍFICA SOBRE LOS 
                      SERVICIOS. POR EJEMPLO, NO ASUMIMOS NINGÚN COMPROMISO RESPECTO AL 
                      CONTENIDO DE LOS SERVICIOS, LA FUNCIÓN ESPECÍFICA DE LOS 
                      SERVICIOS, O SU CONFIABILIDAD, DISPONIBILIDAD O CAPACIDAD PARA 
                      SATISFACER SUS NECESIDADES. PROPORCIONAMOS LOS SERVICIOS "TAL COMO 
                      ESTÁN".
                    </p>
                  </v-alert>
                  
                  <p class="body-1 mb-4">
                    <strong>Responsabilidad por nuestros Servicios:</strong> NGM Corporation 
                    Y SUS PROVEEDORES Y DISTRIBUIDORES NO SERÁN RESPONSABLES POR EL USO O 
                    INFORMACIÓN INGRESADA A LA PLATAFORMA. EN TODOS LOS CASOS EL 
                    CONTRATANTE ASUME LA TOTALIDAD DE RESPONSABILIDAD DE LA 
                    INFORMACIÓN SUMINISTRADA POR TODOS LOS USUARIOS Y EMPLEADOS.
                  </p>
                </v-card-text>
              </v-card>
            </v-tab-item>
            
            <!-- Confidentiality -->
            <v-tab-item>
              <v-card flat>
                <v-card-text class="py-4">
                  <p class="body-1 mb-4">
                    <strong>Confidencialidad:</strong> A menos que una de las partes relevantes de este 
                    acuerdo cuente con un consentimiento previo escrito de su 
                    contraparte:
                  </p>
                  
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">1.1 Preservación de Confidencialidad</v-list-item-title>
                        <v-list-item-subtitle>
                          Cada parte preservará la confidencialidad de toda 
                          la Información Confidencial de la otra, obtenida en relación con 
                          estas CONDICIONES. Ninguna de las partes podrá, sin consentimiento 
                          escrito previo de la otra, liberar o mostrar Información 
                          Confidencial, o usar la misma para su propio beneficio o de 
                          terceros más allá de los establecidos en estas CONDICIONES.
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">1.2 Vigencia de Obligaciones</v-list-item-title>
                        <v-list-item-subtitle>
                          Las obligaciones de ambas partes bajo esta cláusula sobrevivirán a 
                          la finalización de estas CONDICIONES.
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">1.3 Medidas de Seguridad</v-list-item-title>
                        <v-list-item-subtitle>
                          NGM - New Global Market Corp. implementa medidas técnicas y organizativas apropiadas 
                          para garantizar un nivel de seguridad adecuado al riesgo, incluyendo cifrado de datos, 
                          control de acceso estricto, y monitoreo continuo de sistemas.
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  
                  <p class="mt-4 body-1">
                    Nuestros sistemas son desarrollados siguiendo las mejores prácticas de seguridad, incluyendo 
                    las directrices establecidas en ISO 27001, ISO 27017 e ISO 27018, para garantizar la protección 
                    de datos y seguridad de la información.
                  </p>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
    
    <!-- Data Protection Section -->
    <v-row>
      <v-col cols="12">
        <v-card class="mt-6" outlined>
          <v-card-title class="title font-weight-bold">
            <v-icon large color="primary" class="mr-2">mdi-shield-check</v-icon>
            Enfoque en Protección de Datos y Normativas
          </v-card-title>
          
          <v-card-text>
            <p class="body-1 mb-4">
              NGM - New Global Market Corp. implementa robustas medidas de seguridad de la información para 
              proteger los datos de sus clientes. Nuestros procesos siguen las directrices de normas internacionales, 
              incluyendo:
            </p>
            
            <v-row>
              <v-col cols="12" sm="6" md="3" v-for="(cert, i) in certifications" :key="i">
                <v-card class="mb-4 fill-height" :color="cert.color" dark>
                  <v-card-title>{{ cert.title }}</v-card-title>
                  <v-card-text>{{ cert.description }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
            
            <p class="body-1 mt-4">
              Respetamos y consideramos las normativas de privacidad como GDPR (Europa), CCPA (California), 
              PIPEDA (Canadá), y otras regulaciones aplicables según la jurisdicción. Los datos del cliente 
              son procesados únicamente para los fines específicos para los que fueron proporcionados y con 
              medidas de seguridad apropiadas.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <!-- Footer -->
    <v-row class="mt-6">
      <v-col cols="12">
        <div class="text-center">
          <p class="caption grey--text">
            © {{ new Date().getFullYear() }} NGM - New Global Market Corp. Todos los derechos reservados.
            AI-BOS es una marca registrada de NGM - New Global Market Corp.
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AboutView',
  data() {
    return {
      tab: 0,
      features: [
        {
          title: 'Seguridad Avanzada',
          description: 'Implementamos cifrado de datos de extremo a extremo y controles de acceso multicapa para proteger su información.',
          icon: 'mdi-shield-lock',
          color: 'primary'
        },
        {
          title: 'Inteligencia Artificial Ética',
          description: 'Nuestros algoritmos son desarrollados siguiendo principios éticos y con supervisión humana constante.',
          icon: 'mdi-brain',
          color: 'secondary'
        },
        {
          title: 'Cumplimiento Normativo',
          description: 'Cumplimos con los estándares globales de protección de datos para garantizar operaciones legales en cualquier jurisdicción.',
          icon: 'mdi-gavel',
          color: 'success'
        },
        {
          title: 'Escalabilidad Empresarial',
          description: 'Soluciones diseñadas para crecer con su negocio, desde pequeñas empresas hasta corporaciones multinacionales.',
          icon: 'mdi-chart-line',
          color: 'info'
        }
      ],
      certifications: [
        {
          title: 'ISO 27001',
          description: 'Seguimos directrices de Gestión de Seguridad de la Información',
          color: 'primary lighten-1'
        },
        {
          title: 'ISO 27017',
          description: 'Aplicamos recomendaciones para Seguridad en Servicios Cloud',
          color: 'secondary lighten-1'
        },
        {
          title: 'ISO 27018',
          description: 'Consideramos normas para Protección de PII en la Nube',
          color: 'info lighten-1'
        },
        {
          title: 'SOC 2',
          description: 'Contemplamos controles de Seguridad y Disponibilidad',
          color: 'success lighten-1'
        }
      ]
    }
  }
}
</script>
